import { FieldArray } from "formik";
import { Plus, X } from "lucide-react";
import { handleKeyPress } from "../../functions/Utils";
import { OCEAN_FREE_DAY_KEYS, OCEAN_LOAD_TYPE } from "../../utils/constant";

const zeroFreeDays = () =>
  OCEAN_FREE_DAY_KEYS.reduce((acc, k) => ({ ...acc, [k.key]: 0 }), {});

const emptyFreeDay = () => ({
  loadType: "FCL",
  origin: zeroFreeDays(),
  destination: zeroFreeDays(),
});

const FreeDaysForm = ({ formikData, readOnly }) => {
  const { values, setFieldValue } = formikData;
  const freeDays = values.freeDays || [];

  return (
    <FieldArray name="freeDays">
      {({ remove, push }) => (
        <div>
          {freeDays.map((f, index) => (
            <div key={index} className="border border-gray-100 rounded-xl p-4 mb-3.5">
              <div className="flex items-center gap-3.5 mb-4">
                <span className="text-[11px] font-medium text-gray-400 uppercase tracking-wide">
                  Load Type
                </span>
                <select
                  value={f.loadType}
                  onChange={(e) => setFieldValue(`freeDays.${index}.loadType`, e.target.value)}
                  disabled={readOnly}
                  className="h-[38px] px-3 text-sm border border-gray-200 rounded-lg outline-none"
                >
                  {OCEAN_LOAD_TYPE.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
                {!readOnly && freeDays.length > 1 && (
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="w-7 h-7 rounded-full bg-red-50 text-red-300 flex items-center justify-center"
                  >
                    <X size={14} />
                  </button>
                )}
              </div>

              <div className="oc-scroll" style={{ overflowX: "auto" }}>
                <div
                  style={{ minWidth: 900 }}
                  className="grid gap-2.5 items-end"
                >
                  <div className="grid grid-cols-[90px_repeat(6,1fr)] gap-2.5 items-end">
                    <div />
                    {OCEAN_FREE_DAY_KEYS.map((k) => (
                      <div key={k.key} className="text-[11px] font-bold text-gray-500 text-center">
                        {k.label}
                      </div>
                    ))}

                    <div className="text-xs font-bold text-gray-700 pb-2">Origin</div>
                    {OCEAN_FREE_DAY_KEYS.map((k) => (
                      <div key={k.key} className="flex gap-1.5">
                        <input
                          value={f.origin?.[k.key] ?? 0}
                          onChange={(e) =>
                            setFieldValue(
                              `freeDays.${index}.origin.${k.key}`,
                              e.target.value === "" ? "" : Number(e.target.value)
                            )
                          }
                          onKeyPress={handleKeyPress}
                          disabled={readOnly}
                          className="h-[36px] px-2 text-sm text-center border border-gray-200 rounded-md outline-none w-full"
                        />
                        <span className="text-[11px] text-gray-400 self-center flex-none">days</span>
                      </div>
                    ))}

                    <div className="text-xs font-bold text-gray-700 pb-2">Destination</div>
                    {OCEAN_FREE_DAY_KEYS.map((k) => (
                      <div key={k.key} className="flex gap-1.5">
                        <input
                          value={f.destination?.[k.key] ?? 0}
                          onChange={(e) =>
                            setFieldValue(
                              `freeDays.${index}.destination.${k.key}`,
                              e.target.value === "" ? "" : Number(e.target.value)
                            )
                          }
                          onKeyPress={handleKeyPress}
                          disabled={readOnly}
                          className="h-[36px] px-2 text-sm text-center border border-gray-200 rounded-md outline-none w-full"
                        />
                        <span className="text-[11px] text-gray-400 self-center flex-none">days</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}

          {!readOnly && (
            <button
              type="button"
              onClick={() => push(emptyFreeDay())}
              className="flex items-center gap-1.5 text-sm font-semibold px-4 py-2 rounded-lg border border-dashed"
              style={{ borderColor: "#FCB614", color: "#B86E00" }}
            >
              <Plus size={15} /> Add Load Type
            </button>
          )}
        </div>
      )}
    </FieldArray>
  );
};

export default FreeDaysForm;
